<template>
  <div class="container-fluid">
    <div v-if="!submittedSuccessfully" class="py-4 px-lg-5 px-md-2">
      <div class="row">
        <div class="col text-center mb-2">
          <h2 :style="{ color: company.use_custom_styled_widget ? company.storefront_btn_background_color : 'rgba(0, 0, 0, 0.5)' }">Contact Us</h2>
        </div>
      </div>
      <div class="row mt-3 mb-4">
        <div class="col-12 col-md-6 mt-md-4 mb-auto text-center" style="white-space: pre-line">
          <img
            :src="company.logoLink && !company.logoLink.includes('gravatar') ? company.logoLink : '/img/icons/no-company.png'"
            :alt="company.name"
            class="img-fluid company-logo-image"
          />
          <h5 class="text-center text-primary px-md-3 px-lg-5 text-black-50 mb-5 mb-md-0">
            {{ company.public_profile_contact_statement }}
          </h5>
        </div>
        <div class="col-12 col-md-6">
          <BushelTextInput v-model="form.company_name" type="text" :error="submitted && !form.company_name" thin :label-active="'Company Name'" />
          <BushelTextInput v-model="form.contact_name" type="text" thin :error="submitted && !form.contact_name" :label-active="'Contact Name'" />
          <BushelTextInput v-model="form.email" type="text" thin :error="submitted && !validateEmail(form.email)" :label-active="'Contact Email'" />
          <BushelTextInput v-model="form.phone" type="text" thin :label-active="'Contact Phone'" />
          <!-- </div>
        <div class="col-12 col-md-6"> -->
          <BushelTextArea
            v-model="form.message"
            :error="submitted && !form.message"
            type="text"
            :rows="3"
            thin
            :label-active="'Message'"
            class="flex-grow-1"
          />
          <BushelBtn
            ripple-color="success"
            :disabled="submitting"
            class="btn-block py-2"
            :style="{
              backgroundColor: theme ? theme.page_button_color : '',
              color: theme ? theme.page_button_text_color : '',
            }"
            @click="sendContact"
          >
            Submit
          </BushelBtn>
        </div>
      </div>
      <!-- <div class="row">
        <div class="col">
          <BushelBtn
            variant="success"
            ripple-color="success"
            outline
            block
            @click="sendContact"
          >
            Update
          </BushelBtn>
        </div>
      </div> -->
    </div>
    <div v-else class="text-center">
      <Checkmark class="mt-5 mb-3" :title="'Message Sent'" />
      <BushelBtn
        btn-container-class="px-2"
        variant="success"
        ripple-color="success"
        :style="{
          'background-color': company.use_custom_styled_widget ? company.storefront_btn_background_color : '',
          color: company.use_custom_styled_widget ? company.storefront_btn_text_color : '',
        }"
        @click="$emit('hide-contact-sales', true)"
      >
        <i :class="'fa fas fa-angle-left'" />
        Back to menu
      </BushelBtn>
    </div>
  </div>
</template>

<script>
import * as api from "@/services/api";
import Checkmark from "@/components/common/Checkmark.vue";
import { validateEmail } from "@/services/helpers";

export default {
  components: { Checkmark },
  props: {
    company: { type: Object, required: true },
    theme: { type: Object },
    isStoreFront: { type: Boolean, default: false },
    buyer: { type: Object },
    user: { type: Object },
  },
  emits: ["hide-contact-sales"],
  data() {
    return {
      industry: APP_INDUSTRY,
      submitted: false,
      submittedSuccessfully: false,
      submitting: false,
      form: {
        buyer_id: null,
        created_as_buyer: false,
        company_id: this.company.id,
        message: "",
        phone: "",
        email: "",
        contact_name: "",
        company_name: "",
        source: !this.isStoreFront ? "Menu Widget" : "Buyer StoreFront",
      },
    };
  },
  computed: {},
  mounted() {
    this.setBuyerData();
  },
  methods: {
    validateEmail,
    setBuyerData() {
      if (this.buyer && this.user) {
        this.form.buyer_id = this.buyer.id;
        this.form.created_as_buyer = true;
        this.form.company_name = this.buyer.name;
        this.form.contact_name = this.user.name;
        this.form.email = this.user.email;
        this.form.phone = this.user.phone;
      }
    },
    sendContact() {
      this.submitted = true;
      if (this.form.message && this.validateEmail(this.form.email) && this.form.contact_name && this.form.company_name) {
        const that = this;
        this.submitting = true;
        api.post("public-profile-messages", this.form).then(
          (response) => {
            that.submittedSuccessfully = true;
            that.submitting = false;
          },
          (error) => {
            // problem
          },
        );
      }
    },
  },
};
</script>

<style scoped>
.company-logo-image {
  max-height: 120px;
  width: auto;
}
</style>
